/**
 * 
 * @author Edwin Joassart <edwin.joassart@ext.europarl.europa.eu>
 * @copyright European parliament (c) 2020
 * 
 * “One Checkbox to rule them all,
 * One Checbox to find them,
 * One Checkbox to bring them all
 * and in the darkness bind them.”
 * -- J.R.R.
 * 
 * Tick all checkbox at the same level or bellow in the html tree
 * 
 * add 'check-all-children' class and data-check_parent="_parentclass_" to a checkbox
 * replace _parentclass_ with the class of common ancestor of the main checkbox and all the other checkboxes
 * 
 * Follow this html template :
 * 
 
 <ul class="checkbox-list">
  <li>
    <input type="checkbox" class="check-all-checkboxes" data-check_parent="checkbox-list" value="" id="topic0" name="">
    <label for="topic1" class="checkbox-label">All</label>
  </li>
  <li class="checkbox-item list-input">
    <input type="checkbox" value="" id="topic1" name="">
    <label for="topic1" class="checkbox-label">Newsroom</label>
  </li>
</ul>
 
 * 
 */

const DEFAULT_SELECTOR = 'input.check-all-checkboxes';

class CheckAllCheckboxes {
  constructor(element) {
    this.attach(element);
  }

  attach(element) {
    element.addEventListener('change', (event_) => {
      const checkboxes = event_.target
        .closest(`.${event_.target.dataset.check_parent}`)
        .querySelectorAll('input[type="checkbox"]');

      checkboxes.forEach((checkbox) => {
        if (event_.target.checked) checkbox.checked = true;
        else checkbox.checked = false;
      });
    });
  }

  static init(selector) {
    const mainCheckboxes = document.querySelectorAll(
      selector || DEFAULT_SELECTOR
    );
    mainCheckboxes.forEach((checkbox) => new CheckAllCheckboxes(checkbox));
    console.log('check-all-checkboxes init : ok');
  }
}

export default CheckAllCheckboxes;
